import { FormattedHTMLMessage } from "react-intl";

import { getSsoContent } from "../../lib/utils/stepComponentHelpers/stepComponentHelpers";
import { type SSOResponse, type VerificationService } from "../../lib/types/types";
import { VerificationStepsEnum } from "../../lib/types/runtimeTypes";
import { SingleSignOnComponent } from "../SingleSignOnComponent";

interface StepSSOProps {
  verificationService: VerificationService;
}

export const ssoMessages = {
  title: (
    <FormattedHTMLMessage
      id="step.sso.title"
      defaultMessage="Verify using your school credentials"
      tagName="h1"
    />
  ),
  subtitle: (
    <FormattedHTMLMessage
      id="step.sso.subtitle"
      defaultMessage="Please sign in to your school's web portal. It will open in a new tab."
    />
  ),
  login: <FormattedHTMLMessage id="step.sso.login" defaultMessage="Sign in to my school" />,
  cancel: <FormattedHTMLMessage id="step.sso.cancel" defaultMessage="Upload Proof of Enrollment" />,
  subtitle2: (
    <FormattedHTMLMessage id="step.sso.subtitle2" defaultMessage="Can't sign in to your school?" />
  ),
};

export const reclaimMessages = {
  title: (
    <FormattedHTMLMessage
      id="step.reclaim.title"
      defaultMessage="Verify using details from your academic institution"
      tagName="h1"
    />
  ),
  subtitle: (
    <ul>
      <li>
        <FormattedHTMLMessage
          id="step.reclaim.reclaimInfo.consent"
          defaultMessage='By clicking "Verify my status" you consent to completing your verification using the SheerID Verifier.'
        />
      </li>
      <li>
        <FormattedHTMLMessage
          id="step.reclaim.reclaimInfo.login"
          defaultMessage="Your academic institution's portal will open on the next screen. Enter your login credentials to access the website."
        />
      </li>
      <li>
        <FormattedHTMLMessage
          id="step.reclaim.reclaimInfo.display"
          defaultMessage="The SheerID Verifier will automatically identify personal information on the website needed to complete your verification and display it to you."
        />
      </li>
      <li>
        <FormattedHTMLMessage
          id="step.reclaim.reclaimInfo.review"
          defaultMessage="You will have a chance to review the personal information and consent to share it with SheerID and its service providers."
        />
      </li>
    </ul>
  ),
  login: <FormattedHTMLMessage id="step.reclaim.login" defaultMessage="Verify my status" />,
  cancel: <FormattedHTMLMessage id="step.reclaim.cancel" defaultMessage="Verify another way" />,
};

const StepSSOComponent = ({ verificationService }: StepSSOProps) => {
  const verificationResponse = verificationService.verificationResponse as SSOResponse;
  const { isReclaim, messages } = getSsoContent(verificationResponse);

  return (
    <SingleSignOnComponent
      verificationService={verificationService}
      stepName={VerificationStepsEnum.sso}
      messages={messages}
      isReclaim={isReclaim}
    />
  );
};
export { StepSSOComponent };
